module.exports = __webpack_public_path__ + "img/bookmarked.c6eac34f.svg";